export default __webpack_public_path__ + "static/media/lace.cf75434b.png";